import './index.scss'

const speed = 1.5;
const comparisonSliders = document.querySelectorAll('.comparison__scroll');



comparisonSliders.forEach((slider) => {
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('is-dragging');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener('mouseleave', (e) => {
    isDown = false;
    slider.classList.remove('is-dragging');
  });

  slider.addEventListener('mouseup', (e) => {
    isDown = false;
    slider.classList.remove('is-dragging');
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * speed;
    slider.scrollLeft = scrollLeft - walk;
  });
});